import { render } from "./UpdateClaimTypeModal.vue?vue&type=template&id=98e3fda4"
import script from "./UpdateClaimTypeModal.vue?vue&type=script&lang=js"
export * from "./UpdateClaimTypeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__